import React from "react";

// Base Skeleton component
export const Skeleton = ({ width = "100%", height = "20px", borderRadius = "4px", style = {} }) => {
  return (
    <div
      style={{
        width,
        height,
        backgroundColor: "#e5e7eb",
        borderRadius,
        position: "relative",
        overflow: "hidden",
        ...style,
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 0,
          left: "-100%",
          height: "100%",
          width: "100%",
          background:
            "linear-gradient(90deg, transparent, rgba(255,255,255,0.6), transparent)",
          animation: "shimmer 1.5s infinite",
        }}
      />
      <style>
        {`
          @keyframes shimmer {
            0% { left: -100%; }
            100% { left: 100%; }
          }
        `}
      </style>
    </div>
  );
};

// Skeleton for Board Cards Grid
export const BoardCardsSkeleton = ({ count = 6 }) => {
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))",
        gap: "16px",
      }}
    >
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          style={{
            backgroundColor: "white",
            borderRadius: "12px",
            padding: "16px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              marginBottom: "12px",
            }}
          >
            <Skeleton width="40px" height="40px" borderRadius="8px" />
            <Skeleton width="60%" height="20px" />
          </div>
          <Skeleton width="100%" height="14px" style={{ marginBottom: "6px" }} />
          <Skeleton width="80%" height="14px" style={{ marginBottom: "12px" }} />
          <div
            style={{
              display: "flex",
              gap: "6px",
              marginTop: "12px",
              paddingTop: "12px",
              borderTop: "1px solid #e5e7eb",
            }}
          >
            <Skeleton width="48%" height="32px" borderRadius="6px" />
            <Skeleton width="48%" height="32px" borderRadius="6px" />
          </div>
        </div>
      ))}
    </div>
  );
};

// Skeleton for Table
export const TableSkeleton = ({ rows = 5, columns = 3 }) => {
  return (
    <div
      style={{
        backgroundColor: "white",
        borderRadius: "8px",
        overflow: "hidden",
        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
      }}
    >
      {/* Table Header */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: `repeat(${columns}, 1fr)`,
          gap: "16px",
          padding: "16px",
          backgroundColor: "#f9fafb",
          borderBottom: "1px solid #e5e7eb",
        }}
      >
        {Array.from({ length: columns }).map((_, index) => (
          <Skeleton key={index} height="16px" width="80%" />
        ))}
      </div>

      {/* Table Rows */}
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <div
          key={rowIndex}
          style={{
            display: "grid",
            gridTemplateColumns: `repeat(${columns}, 1fr)`,
            gap: "16px",
            padding: "16px",
            borderBottom: rowIndex < rows - 1 ? "1px solid #e5e7eb" : "none",
          }}
        >
          {Array.from({ length: columns }).map((_, colIndex) => (
            <Skeleton
              key={colIndex}
              height="14px"
              width={colIndex === columns - 1 ? "60%" : "90%"}
            />
          ))}
        </div>
      ))}
    </div>
  );
};

// Skeleton for Form Popup Content
export const FormSkeleton = () => {
  return (
    <div>
      {/* Field 1 */}
      <div style={{ marginBottom: "20px" }}>
        <Skeleton width="100px" height="14px" style={{ marginBottom: "8px" }} />
        <Skeleton width="100%" height="40px" borderRadius="6px" />
      </div>

      {/* Field 2 */}
      <div style={{ marginBottom: "24px" }}>
        <Skeleton width="120px" height="14px" style={{ marginBottom: "8px" }} />
        <Skeleton width="100%" height="80px" borderRadius="6px" />
      </div>

      {/* Actions */}
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: "12px",
          paddingTop: "16px",
          borderTop: "1px solid #e5e7eb",
        }}
      >
        <Skeleton width="80px" height="40px" borderRadius="6px" />
        <Skeleton width="100px" height="40px" borderRadius="6px" />
      </div>
    </div>
  );
};

// Skeleton for Empty State
export const EmptyStateSkeleton = () => {
  return (
    <div
      style={{
        textAlign: "center",
        padding: "60px 20px",
        backgroundColor: "white",
        borderRadius: "12px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
      }}
    >
      <Skeleton
        width="64px"
        height="64px"
        borderRadius="50%"
        style={{ margin: "0 auto 16px" }}
      />
      <Skeleton
        width="200px"
        height="20px"
        style={{ margin: "0 auto 8px" }}
      />
      <Skeleton width="250px" height="14px" style={{ margin: "0 auto" }} />
    </div>
  );
};

export default Skeleton;
